import { render, staticRenderFns } from "./SupplierDisplay.vue?vue&type=template&id=c1801a1e"
import script from "./SupplierDisplay.vue?vue&type=script&lang=js"
export * from "./SupplierDisplay.vue?vue&type=script&lang=js"
import style0 from "./SupplierDisplay.vue?vue&type=style&index=0&id=c1801a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports